<template>
  <div class="flex w-full flex-col gap-4">
    <div class="flex items-center justify-center py-24" v-if="isLoading">
      <i v-html="$icons.loading" class="text-ontick-blue-600"></i>
    </div>
    <template v-else>
      <div class="flex flex-col items-center">
        <h2 class="text-xl font-bold">
          {{ order.alg_ord_name }}
        </h2>
        <p class="text-gray-500 dark:text-gray-400">
          {{ order.alg_ord_description || "Long & Short" }}
        </p>
      </div>
      <div class="flex items-center justify-center gap-2">
        <ontick-broker-logo-component :broker="selectedAccount.broker_name" />
        <div class="text-base font-bold">
          <span>
            {{ selectedAccount.broker_name }}
          </span>
          <span class="text-gray-500 dark:text-gray-400"> (#{{ selectedAccount.account_number }}) </span>
        </div>
        <ontick-account-type-badge-component :accountType="selectedAccount.account_type" />
      </div>
      <start-modal-order-description-component
        :symbols="order.symbols"
        :info="info"
        :volumeIsEditable="!!info.alg_ord_code"
        :editableVolume="editableVolume"
        @edit-volume="editableVolume = $event"
      />
      <start-modal-signature-component v-model="signature" v-if="selectedAccount.account_type === 'PRD'" />
      <div class="flex items-center justify-center">
        <button
          @click="startOrder"
          :disabled="selectedAccount.account_type === 'PRD' && signature.length < 4"
          class="bg-ontick-blue-600 dark:bg-ontick-blue-800 text-ls flex items-center justify-center rounded py-4 px-12 font-bold uppercase shadow filter transition-all hover:brightness-125 disabled:cursor-not-allowed disabled:bg-gray-600 disabled:text-gray-400 disabled:filter-none"
        >
          Iniciar estratégia
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ontickAccountTypeBadgeComponent from "../../../shared/components/basic/ontick-account-type-badge.component.vue";
import OntickBrokerLogoComponent from "../../../shared/components/basic/ontick-broker-logo.component.vue";
import event_bus from "../../../shared/utils/event_bus";
import StartModalOrderDescriptionComponent from "./start-modal-order-description.component.vue";
import StartModalSignatureComponent from "./start-modal-signature.component.vue";

export default {
  components: {
    ontickAccountTypeBadgeComponent,
    OntickBrokerLogoComponent,
    StartModalOrderDescriptionComponent,
    StartModalSignatureComponent,
  },

  props: {
    order: {
      type: Object,
    },
  },

  data() {
    return {
      signature: "",
      info: {},
      isLoading: false,
      editableVolume: 0,
    };
  },

  computed: {
    ...mapGetters({ getSelectedAccount: "accountTypes/getSelectedAccount" }),
    selectedAccount() {
      return Object.assign({}, this.getSelectedAccount);
    },
    numericVolume() {
      if (typeof this.editableVolume === "string") {
        return Number(this.editableVolume.replaceAll("R$ ", "").replaceAll(".", "").replaceAll(",", "."));
      }
      return this.editableVolume;
    },
  },

  methods: {
    getOrderInfo() {
      return this.$api
        .get(this.$endpoint.GET_ALGO_ORDER_DETAILS, {
          params: {
            account_id: this.selectedAccount.account_id,
            alg_ord_id: this.order.alg_ord_id,
          },
        })
        .then((res) => {
          // console.log(res);
          this.info = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    startOrder() {
      return this.$api
        .post(this.$endpoint.START_ALGO_ORDER, {
          // parâmetros obrigatórios
          account_id: this.selectedAccount.account_id,
          alg_ord_id: this.order.alg_ord_id,

          // parâmetros opcionais
          volume: this.numericVolume && this.numericVolume !== 0 ? this.numericVolume : undefined,
          user_code: this.selectedAccount.account_type === "PRD" ? this.signature : undefined,
        })
        .then((res) => {
          // console.log(res);
          this.$swal("Operação iniciada", res.data.msg, "success").then(() => {
            this.$emit("close");
          });
          event_bus.$emit("RELOAD_ALGO_ORDERS");
        })
        .catch((err) => {
          console.error(err);
          this.$swal("Erro", err.data.msg, "error");
        });
    },
    itemLogo(broker_name, account_type) {
      switch (broker_name) {
        case "OnTick":
          return this.$icons.ontick;

        case "XP":
          return this.$icons.xp;

        case "Cripto":
          return this.$icons.bitcoin;

        case "RICO":
          return this.$icons.rico_badge;

        case "CLEAR":
          return this.$icons.clear_light_badge;

        case "XTAGE":
          return this.$icons.xtage_badge;

        case "Campeonato":
          return this.$icons.trophy;
      }
      if (account_type === "CONTEST") {
        return this.$icons.trophy;
      }
    },
  },

  mounted() {
    this.isLoading = true;
    this.getOrderInfo().finally(() => {
      this.isLoading = false;
    });
  },
};
</script>

<style></style>
